var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ToolbarItemContainer', {
    ref: "container",
    attrs: {
      "iconFile": _vm.faceIcon,
      "title": _vm.TUITranslateService.t('表情'),
      "isH5EmojiShow": _vm.props.isH5EmojiShow,
      "isH5Emoji": _vm.isH5
    },
    on: {
      "onDialogShow": _vm.onDialogShow,
      "onDialogClose": _vm.onDialogClose
    }
  }, [_c('EmojiPickerDialog', {
    on: {
      "insertEmoji": _vm.insertEmoji,
      "sendMessage": _vm.sendMessage,
      "onClose": _vm.onClose
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }